<template>
    <Card :title="$t('labels.integrationOrder')">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-4">
                            <FormGroup :label="$t('labels.status')">
                                <Input :model-value="integrationOrder?.status?.name" :disabled="true"/>
                            </FormGroup>
                        </div>
                        <div class="col-4">
                            <FormGroup :label="$t('labels.source_id')">
                                <Input :model-value="integrationOrder?.source_id" readonly/>
                            </FormGroup>
                        </div>
                        <div class="col-4">
                            <FormGroup :label="$t('labels.source_number')">
                                <Input :model-value="integrationOrder?.source_number" readonly/>
                            </FormGroup>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <span class="d-flex justify-content-center" v-if="!jsonDump">
                        <Button size="sm" color="indigo d-block" @click="fetchJsonDump"  :disabled="!order.integration_order || loading">
                            <i :class="['icon-spinner4 mr-2', loading ? 'spinner': '']"></i>
                            {{ $t('buttons.fetch_json_structure') }}
                        </Button>
                    </span>
                    <JsonViewer v-else :model-value="jsonDump" height="800px"/>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import InputTextArea from "../../../../../components/new/form/InputTextArea.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import JsonViewer from '../../../../components/viewer/JsonViewer.vue';

import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: "IntegrationOrderCard",
    components: {
        Card, FormGroup, Input, InputTextArea, Button, JsonViewer
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            integrationOrder: null,
            jsonDump: null,
            loading: false,
        }
    },
    methods: {
        fetchOrder() {
            if (!this.order.integration_order) {
                return;
            }

            httpClient.get(`/integrations/${this.order.integration_order.integration.uuid}/orders/${this.order.integration_order.uuid}`).then((response) => {
                this.integrationOrder = response.data.data
            })
        },
        fetchJsonDump() {
            this.loading = true
            httpClient.get(`/integrations/${this.order.integration_order.integration.uuid}/orders/${this.order.integration_order.uuid}/json-dump`).then((response) => {
                this.jsonDump = response.data.data
            }).then((response) => {
                this.jsonDump = response.data.data
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
    },
    mounted() {
        this.fetchOrder()
    }
}
</script>